import { render, staticRenderFns } from "./Operasi.vue?vue&type=template&id=2423a8a3&"
import script from "./Operasi.vue?vue&type=script&lang=js&"
export * from "./Operasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports